import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { projectsEntries } from "@/models/Projects";

function importAll(r) {
  var images = {};
  r.keys().map(function (item) {
    images[item.replace("./", "").split(".")[0]] = r(item);
  });
  return images;
}

var projectsBanners = importAll(require.context("@/assets/img/projects", false, /\.(png|jpe?g|svg)$/));
var projectsThumbs = importAll(require.context("@/assets/img/projects/thumbs", false, /\.(png|jpe?g|svg)$/));
export default defineComponent({
  name: "ProjectsView",
  data: function data() {
    return {
      projectsEntries: projectsEntries,
      projectsBanners: projectsBanners,
      projectsThumbs: projectsThumbs
    };
  },
  methods: {
    faIcon: function faIcon(type) {
      switch (type) {
        case "development":
          return "fas fa-code";

        case "cloud-computing":
          return "fas fa-cloud-upload-alt";
      }

      return "";
    }
  },
  setup: function setup() {
    return useI18n();
  }
});